
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient, EntidadeInfo, ExercicioInfo } from '@elotech/angular-common';


@Injectable()
export class EntidadeService {

  constructor(public httpClient: HttpClient) {
  }

  public findEntidades(): Observable<Array<EntidadeInfo>> {
    return this.httpClient.get({ resource: '/api/entidades' })
      .pipe(
        map(res => res.content)
      );
  }

  public findExercicios(id): Observable<Array<ExercicioInfo>> {
    return this.httpClient.get({ resource: `/api/entidades/${id}/exercicios`});
  }

  public findCompetencias(exercicio: any, entidade: any): Observable<Array<any>> {

    return this.httpClient.get({ resource: `/api/competencias/${exercicio}/${entidade}` });
  }

  public getEntidadeBrasaoById(entidadeId: number): Observable<any>{
    return this.httpClient.get({
      resource: `/api/entidades/brasao/${entidadeId}`,
      disableSpinner: true
    });
  }
}
